import useGetConfirmationModalContent from './useGetConfirmationModalContent'

export default useGetConfirmationModalContent
